import { FC } from 'react'
import { postPage_indexQuery$data } from '@/queries/__generated__/postPage_indexQuery.graphql'
import { NotFound } from '@lifedot/components/NotFound'
import { PostNoTitle } from '@/components/PostNoTitle'

interface SingleColumnPostTemplateProps {
  data: postPage_indexQuery$data | null | undefined
}

export const SingleColumnPostTemplate: FC<SingleColumnPostTemplateProps> = ({
  data
}) => {
  if (!data?.post) return <NotFound />

  return <PostNoTitle {...data} />
}
